module.exports = __webpack_public_path__ + "img/pdf.d1f16a68.svg";